import * as R from 'ramda'
import { handleActions } from 'redux-actions'

import a from './actions'

const init = {
  clientId: null,
  title: null,
  slug: null,
  authenticated: false,
  accessToken: undefined,
  accessTokenIssuedAt: undefined,
  token: undefined,
  realm: 'merchants',
  useBaseName: true,
  mids: [],
  selectedMid: undefined,
  showBetaLabel: false,
  isUpdateProfileLoading: false,
  isUpdateProfileFailed: false,
  designVersion: null,
  sessionId: undefined,
  requester: undefined,
  isPartner: false
}

const filterRequester = R.pick(['totp', 'attributes', 'capabilities', 'hasAcceptedNKOTerms', 'is_kred'])

export default handleActions({
  [a.token.set]: (state, { payload: keycloak }) => ({
    ...state,
    authenticated: true,
    accessToken: keycloak.token,
    accessTokenIssuedAt: R.path(['tokenParsed', 'iat'], keycloak)
  }),
  [a.keycloak.realm.set]: (state, { payload }) => ({
    ...state,
    realm: payload
  }),
  [a.keycloak.realm.clear]: state => ({
    ...state,
    realm: 'merchants'
  }),
  [a.profile.updating]: state => ({
    ...state,
    isUpdateProfileLoading: true,
    isUpdateProfileFailed: false
  }),
  [a.profile.update.succeeded]: state => ({
    ...state,
    isUpdateProfileLoading: false,
    isUpdateProfileFailed: false
  }),
  [a.profile.update.failed]: state => ({
    ...state,
    isUpdateProfileFailed: true,
    isUpdateProfileLoading: false
  }),
  [a.requester.fetch]: (state, { error, payload }) => {
    return (error || !payload)
      ? state
      : {
        ...state,
        requester: filterRequester(payload)
      }
  },
  [a.requester.update]: (state, { error, payload }) => ({
    ...state,
    requester: {
      ...state.requester,
      ...(error ? {} : filterRequester(payload))
    }
  }),
  [a.mids.set]: (state, { payload: mids }) => ({
    ...state,
    mids,
    selectedMid: state.selectedMid || mids[0]
  }),
  [a.mid.set]: (state, { payload: selectedMid }) => ({
    ...state,
    selectedMid
  }),
  [a.isPartner.set]: (state, { payload: isPartner }) => ({
    ...state,
    isPartner
  })
}, init)
